<div *ngIf="!isApp" id="edp-tour-consumption-local" class="consumption-local">
    <a (click)="showContractList(true)">
        <span class="d-block position-relative">
            <span class="d-inline-block align-middle">
                {{ contract?.Nickname }}
            </span>
            <span class="position-absolute">
                <i class="mt-n1 font-weight-bold icon-edponline-Bop-073 rotate-270"  aria-hidden="true"></i>
            </span>
        </span>
        <span class="subtitle text-truncate">{{ "pt.edp.edponline.contract.consumption.local.select" | translate }}</span>
    </a>
</div>

<div *ngIf="isApp" id="edp-tour-app-consumption-local" class="consumption-local-app d-flex p-3 align-items-center d-block d-lg-none">
    <div class="m-auto">
        <a *ngIf="showContractName" class="d-flex flex-column align-items-center" (click)="showContractList(true)">
            <div>
                <span class="text-truncate highlight-red" [ngClass]="{'with-scroll': scroll}">{{ contract?.Nickname }}</span>
                <span class="ml-2 d-lg-none">
                    <i class="icon-edponline-Bop-073 icon-size align-middle highlight-red"  aria-hidden="true"></i>
                </span>
            </div>
            <span class="subtitle app-subtitle text-truncate">{{ "pt.edp.edponline.contract.consumption.local.select" | translate }}</span>
        </a>
        <a *ngIf="!showContractName" class="d-flex align-items-center">
            <span class="d-inline-block d-lg-none title "
                [ngClass]="{'with-scroll': scroll}">{{ menuTitle | translate }}
            </span>
        </a>
    </div>
</div>